import { Ad } from "@/types/ad";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface Props {
  ads: Ad[];
  numbersByAd: Record<string, string | undefined>;
  onBuyNumber: (ad: Ad) => void;
  onToggleStatus: (ad: Ad) => void;
  onDeleteAd: (ad: Ad) => void;
}

export function AdsTable({ ads, numbersByAd, onBuyNumber, onToggleStatus, onDeleteAd }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Number</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {ads.map((ad) => {
          const e164 = numbersByAd[ad.id];
          return (
            <TableRow key={ad.id}>
              <TableCell>{ad.name}</TableCell>
              <TableCell className="capitalize"><Badge variant={ad.status === 'active' ? 'default' : ad.status === 'paused' ? 'secondary' : 'outline'}>{ad.status}</Badge></TableCell>
              <TableCell>{e164 || '—'}</TableCell>
              <TableCell className="text-right flex items-center justify-end gap-2">
                <Button size="sm" variant="ghost" onClick={() => onToggleStatus(ad)}>
                  {ad.status === 'active' ? 'Pause' : 'Activate'}
                </Button>
                <Button size="sm" variant="outline" onClick={() => onBuyNumber(ad)} disabled={!!e164}>Buy number</Button>
                <Button size="sm" variant="destructive" onClick={() => onDeleteAd(ad)}>Delete</Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
